export default "<app-main-nav [ContentType]=\"2\">\n  <app-header></app-header>\n  <router-outlet></router-outlet>\n</app-main-nav>\n"